import { render, staticRenderFns } from "./EnhancedTable.vue?vue&type=template&id=27c0c4f6&"
import script from "./EnhancedTable.vue?vue&type=script&lang=js&"
export * from "./EnhancedTable.vue?vue&type=script&lang=js&"
import style0 from "./EnhancedTable.vue?vue&type=style&index=0&id=27c0c4f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports